import styled from 'styled-components';

export const FeedbackContainer = styled.div`
  display: flex;
  height: 100vh;
`;
